import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

function Header({ bannerContent, loading }) {
  return (
    <>
      <div className="header wf-section">
        <div className="center">
          <div className="header__container">
            <a href="https://www.ens.edu.br/" target="_blank" className="header__link">Ir para o site da ENS</a>
          </div>
        </div>
      </div>
      <section className="section__banner">
        <div className="center pos-relative">
          <div className="banner__menu">
            <a href="#" className="unisincor-logo-link w-inline-block">
              <img src="/assets/images/landing-unisincor-logo.png" loading="lazy" alt="Logo Unisincod" className="logo-unisincor" /></a>
            <a href="#" className="ens-logo-link w-inline-block">
              <img src="/assets/images/logo.png" loading="lazy" alt="Logo ENS" className="logo-ens" /></a>
          </div>
        </div>
        <div className="banner__info">
          <div className="center banner__info-container pos-relative">
            {
              loading 
              ? 
                <div className="banner__info-block">
                  <SkeletonTheme baseColor="#aad7db14" highlightColor="#9fcfd3" height="25px">
                    <Skeleton width={"40%"}/>
                    <Skeleton width={"80%"}/>
                    <Skeleton width={"80%"}/>
                    <Skeleton width={"40%"}/>
                    <Skeleton count={5}/>
                  </SkeletonTheme>
                </div>
              :  <div className="banner__info-block">
                  <div className="banner__info-uppertitle">{bannerContent?.banner_upper}</div>
                  <div className="banner__info-title" dangerouslySetInnerHTML={{ __html: bannerContent?.banner_title }}></div>
                  <div className="banner__info-description" dangerouslySetInnerHTML={{ __html: bannerContent?.banner_content }}></div>
                </div>
            }
          
          </div>
        </div>
        <img src={bannerContent?.banner} sizes="100vw" alt="" className="banner__desktop-image" />
        <div className='fade-effect'></div>
      </section>
    </>
  )
}

export default Header